import { render, staticRenderFns } from "./DoKoProfileEdit.vue?vue&type=template&id=44df8752&scoped=true&"
import script from "./DoKoProfileEdit.vue?vue&type=script&lang=ts&"
export * from "./DoKoProfileEdit.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoProfileEdit.vue?vue&type=style&index=0&id=44df8752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df8752",
  null
  
)

export default component.exports